import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import ChatBox from "../landlord/ChatBox";

function TenChatPage() {
  const { t, h, tens, currUserId } = useContext(Ctx); const ct = currUserId; const me = tens.find(x => x.id === ct);
  // FIX #13: Show a message if tenant has no assigned property instead of wrong chat
  if (!me?.pid) return <div style={{ paddingTop: 16 }}><h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, marginBottom: 16 }}>{t.chat}</h2><div style={{ color: h.sc, textAlign: "center", padding: 40, fontSize: 13 }}>{t.noPropChat}</div></div>;
  return <div style={{ paddingTop: 16 }}><h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, marginBottom: 16 }}>{t.chat} - Landlord</h2><ChatBox pid={me.pid} sender={ct} /></div>;
}

export default TenChatPage;
